import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RequestAccessTable } from '@/app/(client)/documents/-components/RequestAccessTable';
import { requestAccessQueryOptions } from '@/hooks/useDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
});

export const Route = createFileRoute(
  '/(client)/documents/(pages)/(list)/request-access/',
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    sort: search.sort,
  }),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      requestAccessQueryOptions({
        page: deps.page - 1,
        count: deps.limit,
        ...(deps.sort ? { sort: deps.sort } : {}),
      }),
    ),
  component: RequestAccessTab,
});

function RequestAccessTab() {
  return <RequestAccessTable />;
}
